import dayjs, { Dayjs } from 'dayjs'

import { FormItem } from '@eastcoal/formily/components/FormItem'
import { Input } from '@eastcoal/formily/components/Input'
import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

import { KindAllNodeCascader } from '@eastcoal/shared/@formily/KindAllNodeCascader'

import { DepositInput } from '../components/DepositInput'
import { EndTimePicker } from '../components/EndTimePicker'
import { SignUpEndTimePicker } from '../components/SignUpEndTimePicker'
import { SignUpStartTimePicker } from '../components/SignUpStartTimePicker'
import { StartTimePicker } from '../components/StartTimePicker'
import { depositValidator } from '../validators/deposit'
import { endTimeValidator } from '../validators/endTime'
import { signUpEndTimeValidator } from '../validators/signUpEndTime'
import { signUpStartTimeValidator } from '../validators/signUpStartTime'
import { startTimeValidator } from '../validators/startTime'

export const basicSchema: Record<string, SchemaItem> = {
  title: {
    title: '场次标题',
    type: 'string',
    'x-pattern': 'disabled',
    'x-decorator': FormItem,
    'x-component': Input,
    'x-component-props': {
      placeholder: '根据公司名和品种自动生成'
    }
  },
  projectName: {
    title: '项目名称',
    type: 'string',
    required: true,
    'x-decorator': FormItem,
    'x-component': Input
  },
  '{depositMethod,depositValue}': {
    type: 'number',
    title: '保证金',
    'x-decorator': FormItem,
    'x-component': DepositInput,
    'x-validator': depositValidator
  },
  [`{
    id: kindId,
    name: kindName,
    code: kindCode
  }`]: {
    title: '品种',
    type: 'object',
    required: true,
    'x-decorator': FormItem,
    'x-component': KindAllNodeCascader
  },
  signUpStartTime: {
    type: 'string',
    title: '报名开始时间',
    'x-decorator': FormItem,
    'x-component': SignUpStartTimePicker,
    'x-component-props': {
      disabledDate: (currentDate: Dayjs) =>
        currentDate.isBefore(dayjs(), 'date')
    },
    'x-validator': signUpStartTimeValidator
  },
  signUpEndTime: {
    type: 'string',
    title: '报名结束时间',
    'x-decorator': FormItem,
    'x-component': SignUpEndTimePicker,
    'x-component-props': {
      disabledDate: (currentDate: Dayjs) =>
        currentDate.isBefore(dayjs(), 'date')
    },
    'x-validator': signUpEndTimeValidator
  },
  startTime: {
    type: 'string',
    title: '比价开始时间',
    'x-decorator': FormItem,
    'x-component': StartTimePicker,
    'x-component-props': {
      disabledDate: (currentDate: Dayjs) =>
        currentDate.isBefore(dayjs(), 'date')
    },
    'x-validator': startTimeValidator
  },
  endTime: {
    type: 'string',
    title: '比价结束时间',
    'x-decorator': FormItem,
    'x-component': EndTimePicker,
    'x-component-props': {
      disabledDate: (currentDate: Dayjs) =>
        currentDate.isBefore(dayjs(), 'date')
    },
    'x-validator': endTimeValidator
  }
}
